var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: _vm.$style.container,
        on: {
            "click": _setup.onRefresh
        }
    }, [
        _c('p', [
            _vm._v("页面加载异常，点击刷新重试")
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
